import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { ADMIN_BASE } from "../config";

export default function AuthCallback() {
    const { setAdmin } = useAuth();
    const navigate = useNavigate();
    const done = useRef(false);

    useEffect(() => {
        if (done.current) return;
        done.current = true;
        const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
        const sid = params.get("session_id");
        if (!sid) {
            navigate(ADMIN_BASE, { replace: true });
            return;
        }
        api
            .post("/auth/session", null, { headers: { "X-Session-ID": sid } })
            .then((r) => {
                setAdmin(r.data.user);
                window.history.replaceState(null, "", ADMIN_BASE);
                navigate(r.data.user.status === "approved" ? "/admin" : ADMIN_BASE, {
                    replace: true,
                });
            })
            .catch(() => {
                setAdmin(false);
                navigate(ADMIN_BASE, { replace: true });
            });
    }, [setAdmin, navigate]);

    return (
        <div className="flex min-h-screen items-center justify-center bg-[#070c18] text-slate-300/70">
            Signing you in…
        </div>
    );
}
